import { render, staticRenderFns } from "./AddFinance.vue?vue&type=template&id=80c5186e"
import script from "./AddFinance.vue?vue&type=script&lang=js"
export * from "./AddFinance.vue?vue&type=script&lang=js"
import style0 from "./AddFinance.vue?vue&type=style&index=0&id=80c5186e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports